import { render, staticRenderFns } from "./ReleaseView.vue?vue&type=template&id=0218b6a8&scoped=true"
import script from "./ReleaseView.vue?vue&type=script&lang=js"
export * from "./ReleaseView.vue?vue&type=script&lang=js"
import style0 from "./ReleaseView.vue?vue&type=style&index=0&id=0218b6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218b6a8",
  null
  
)

export default component.exports